module.exports = __webpack_public_path__ + "img/top_left.b634fcde.svg";